/**
 * QUIET — Custom JavaScript
 * Allineato al wireframe HTML + Bootstrap 5
 *
 * - Navbar scroll + mobile toggle
 * - Smooth scroll con offset navbar
 * - Active nav link (IO)
 * - Hero Swiper (condizionale)
 * - PhotoSwipe 5 gallery (dynamic ESM import)
 * - Scroll reveal (IO)
 *
 * Nota: i tab menu usano Bootstrap 5 tabs (data-bs-toggle)
 */

(function () {
    'use strict';
  
    // ── NAVBAR SCROLL ────────────────────────────────────────
    const navbar = document.getElementById('navbar');
  
    if (navbar) {
      const onScroll = () => {
        navbar.classList.toggle('is-scrolled', window.scrollY > 80);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
  
      // Mobile hamburger toggle
      const toggler = navbar.querySelector('[aria-label="Menu"]');
      const navMenu = navbar.querySelector('.navbar-collapse, .d-lg-flex');
      if (toggler && navMenu) {
        toggler.addEventListener('click', () => {
          navMenu.classList.toggle('is-open');
          document.body.classList.toggle('nav-open');
        });
      }
    }
  
    // ── SMOOTH SCROLL (con offset navbar) ──────────────────
    document.querySelectorAll('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => {
        e.preventDefault();
        const target = document.querySelector(a.getAttribute('href'));
        if (target) {
          const offset = navbar ? navbar.offsetHeight : 0;
          window.scrollTo({
            top: target.getBoundingClientRect().top + window.scrollY - offset,
            behavior: 'smooth'
          });
        }
      });
    });
  
    // ── ACTIVE NAV LINK ON SCROLL ──────────────────────────
    if (navbar) {
      const sections = document.querySelectorAll('section[id]');
      const navLinks = navbar.querySelectorAll('.nav-link[href^="#"]');
  
      const navObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('id');
            navLinks.forEach(link => {
              link.classList.toggle('active', link.getAttribute('href') === '#' + id);
            });
          }
        });
      }, { rootMargin: '-40% 0px -60% 0px' });
  
      sections.forEach(s => navObserver.observe(s));
    }
  
    // ── HERO SWIPER (condizionale) ─────────────────────────
  const heroSwiper = document.querySelector('.hero-swiper');
  if (heroSwiper && typeof Swiper !== 'undefined') {

      new Swiper('.hero-swiper', {
          loop: true,
          speed: 800,
          autoplay: { delay: 6000, disableOnInteraction: false },
          effect: 'fade',
          fadeEffect: { crossFade: true },
          pagination: {
              el: '.hero-pagination-bullets',
              clickable: true,
              renderBullet: function (index, className) {
                  return '<button class="' + className + '" aria-label="Slide ' + (index + 1) + '">'
                      + '<span class="hero-bullet-fill"></span>'
                      + '</button>';
              }
          },
          on: {
              slideChange: function () {
                  var el = document.querySelector('.hero-slide-current');
                  if (el) {
                      var real = this.realIndex + 1;
                      el.textContent = real < 10 ? '0' + real : real;
                  }
              }
          }
      });
  }
  
    // ── PHOTOSWIPE 5 (dynamic ESM import) ──────────────────
    const galleryGrid = document.querySelector('.gallery-grid');
    if (galleryGrid && galleryGrid.querySelector('a[data-pswp-width]')) {
      Promise.all([
        import('https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe-lightbox.esm.min.js'),
        import('https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe.esm.min.js')
      ]).then(([{ default: PhotoSwipeLightbox }, { default: PhotoSwipe }]) => {
        new PhotoSwipeLightbox({
          gallery: '.gallery-grid',
          children: 'a',
          pswpModule: PhotoSwipe,
          bgOpacity: 0.92,
          padding: { top: 20, bottom: 20, left: 20, right: 20 }
        }).init();
      }).catch(() => {});
    }
  
    // ── SCROLL REVEAL (IO) ────────────────────────────────
    const reveals = document.querySelectorAll('.reveal');
    if (reveals.length) {
      const revealObs = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            revealObs.unobserve(e.target);
          }
        });
      }, { threshold: 0.15 });
  
      reveals.forEach(el => revealObs.observe(el));
    }
  
  })();